import React, {useState} from 'react'
import RightSignIn from "../../assets/images/right-sign.svg"
import Unchacked from "../../assets/images/right-signUnCheck.svg"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GLogin from '../SocialMedia/googleLogin'
import { useHistory } from 'react-router';
import Logo from '../../assets/images/EZ_LEISURE_LOGO.svg';
import {
  EmailValidation, 
  NameValidation, 
  PhoneValidation, 
  PasswordValidation
} from '../../utils/Validation.js';
import { Post, Put} from '../../Api/ApiMethods.js';
import {
  signUpUrl,
  rqstOtpForEmailVerificationUrl,
 } from '../../Routes/ApiRoutes';


export default function SignUp() {
  const history = useHistory()
  const [data ,setData] = useState({
    "phone": '',
    "country_code": "+91",
    "username": "",
    "email": "",
    "address": "",
    "password": "",
    "confirm_password": ""
  });
  const [termCondition, setTermCondition] = useState(false);
  const [emailError, setEmailError] = useState(null);
  const [nameError, setNameError] = useState(null);
  const [phoneError, setPhoneError] = useState(null);
  const [addressError, setAddressError] = useState(null);
  const [passError, setPassError] = useState(null);
  const [confrmPassError, setConfrmPassError] = useState(null);


  const onSubmit = () => {
    if(termCondition)
    { 
      if(data.username === '')
      {
        setNameError('Username cannot be blank.')
      }
      if(data.email === '')
      {
        setEmailError('Email id cannot be blank.')
      }
      if(data.phone === '')
      {
        setPhoneError('Phone cannot be blank.')
      }
      // if(data.address === '')
      // {
      //   setAddressError('Address cannot be blank.')
      // }
      if(data.password === '')
      {
        setPassError('Password cannot be blank.')
      }
      if(data.confirm_password === '')
      {
        setConfrmPassError('Confirm password cannot be blank.')
      }
      if(data.username !== '' && data.email !== '' && data.phone !== '' && data.password !== '' &&
      data.confirm_password !== '' && !(confrmPassError) && !(passError) && !(phoneError)
      && !(emailError) && !(nameError)){
        try {
        Post(signUpUrl, '', data)
        .then(response => { 
          toast.success("User Successfully Created.");
          setTimeout(() =>
            history.push({ 
            pathname: '/verifyEm',
            state : data
          }), 2100)
        })
        .catch(error => {
          toast.error(error.error)
        })
      }catch (error) {
        console.log(error);
      }}
    }
    else{
      toast.error("Please accept terms and condition to continue.")
    }
  }

var handleEmailsInput = (e) => {
  if(EmailValidation(e.target.value))
  {
     let updatedDetails = { ...data };
     updatedDetails[e.target.id] = e.target.value;
     setData(updatedDetails)

     setEmailError(null);
  }
  else{
   setEmailError('Invalid email id.');
  }
}

var handleNameInput = (e) => {
  if(NameValidation(e.target.value))
  {
     let updatedDetails = { ...data };
     updatedDetails[e.target.id] = e.target.value;
     setData(updatedDetails)

     setNameError(null);
  }
  else{
    setNameError('Invalid format of username.');
  }
}

var handlePhoneInput = (e) => {
  if(PhoneValidation(e.target.value))
  {
     let updatedDetails = { ...data };
     updatedDetails[e.target.id] = e.target.value;
     setData(updatedDetails)

     setPhoneError(null);
  }
  else{
    setPhoneError('Invalid format of phone number.');
  }
}

var handleConfrmPassInput = (e) => {
  if(data.password == e.target.value)
  { 
    let updatedDetails = { ...data };
    updatedDetails[e.target.id] = e.target.value;
    setData(updatedDetails)

    setConfrmPassError(null);
  }
  else{
    setConfrmPassError('It does not match with password.');
  }
}

var handlePassInput = (e) => {
  if(PasswordValidation(e.target.value))
  {
    let updatedDetails = { ...data };
    updatedDetails[e.target.id] = e.target.value;
    setData(updatedDetails)
    
    setPassError(null);
  }
  else{
    setPassError('Must have at least one uppercase letter, one lowercase letter, one number and one of the special characters #?!@$%^&*-.');
  }
}

var handleAddressInput = (e) => {
    let updatedDetails = { ...data };
		updatedDetails[e.target.id] = e.target.value;
    setData(updatedDetails)
    setAddressError(null)
}

let termConditionPage = () => {
  return (
    <>
    
    </>
  )
}

    return (<>
        <section className="header">
            <div className="container">
                <nav className="navbar navbar-expand-lg navbar-light bg-light login-header">
                <a className="navbar-brand" href="#">
                    <img className="img-fluid" src={Logo} />
                </a>
                </nav>
            </div>
        </section>
        <ToastContainer position="top-center" autoClose={2000}/>
        <section style={{marginTop:'-73px'}} className="sign-in-wrapper">
          <div className="container">
            <div className="sign-in">
              <h2>SIGN UP</h2>
                  <div className="form-group">
                    <input className={nameError ? "form-control borderRed" : "form-control" } onChange={(e) => handleNameInput(e)} 
                    id='username' type="text" placeholder="Name" />
                    {nameError && <span className='form-error'>{nameError}</span>}
                  </div>
                  <div className="form-group">
                    <input className={emailError ? "form-control borderRed" : "form-control" } onChange={(e) => handleEmailsInput(e)} 
                    type="text" id='email' placeholder="Email" />
                     {emailError && <span className='form-error'>{emailError}</span>}
                  </div>  
                  <div className="form-group">
                    <input className={phoneError ? "form-control borderRed" : "form-control" } onChange={(e) => handlePhoneInput(e)} 
                    type="number" id='phone'  placeholder="Phone number" />
                    {phoneError && <span className='form-error'>{phoneError}</span>}
                  </div>
                  <div className="form-group" 
                  // style={{display:'none', visibility:'hidden'}}
                  >
                      <input className={addressError ? "form-control borderRed" : "form-control" } onChange={(e) => handleAddressInput(e)}
                       type="text" id='address'  placeholder="Address" />
                       {addressError && <span className='form-error'>{addressError}</span>}
                  </div>
                  <div className="form-group">
                      <input className={passError ? "form-control borderRed" : "form-control" } onChange={(e) => handlePassInput(e)}
                       type="password" id='password' placeholder="Password" />
                       {passError && <span className='form-error'>{passError}</span>}
                  </div>
                  <div className="form-group">
                      <input className={confrmPassError ? "form-control borderRed" : "form-control" } onChange={(e) => handleConfrmPassInput(e)}
                       type="password" id='confirm_password' placeholder="Confirm Password" />
                       {confrmPassError && <span className='form-error'>{confrmPassError}</span>}
                  </div>
            
                  <div className="Terms-Conditions">
                    <h5>
                      <img onClick={() => setTermCondition(!termCondition)} src={termCondition ? RightSignIn : Unchacked} />
                      I accept the <a className='link'>Terms & Conditions</a></h5>
                  </div>
              <div className="comman-btn">
                <button onClick={onSubmit} type='button'>Sign up</button>
              </div>
              <div className="sign-in-with">
                <p>Sign up with <GLogin termCondition={termCondition} /></p>
                <div className="Not-member">
                  <p>Already member? <a className='link' onClick={() => history.push(`/login`)}>Sign in</a></p>
                </div>
              </div>
            </div>
          </div>
    </section>
    </>);
}
